import React, { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import LoginForm from "./LoginForm";
import InfoForm from "./InfoForm";
import ForgotPasswordForm from "./ForgotPasswordForm";

const AuthModal = ({ openModal, closeModal, fromDashboard }) => {
  const [swap, setSwap] = useState("login");
  // useEffect(() => {
  //   if (closeModal === true) {
  //     setSwap("login");
  //   }
  // });
  return (
    <>
      <Modal show={openModal} onHide={closeModal} onExited={()=> setSwap("login")} >
        <Modal.Body>
         
          {swap === "login" ? (
            <LoginForm setSwap={setSwap} dashboard={fromDashboard}/>
          ) : swap === "profileSetup" ? (
            <InfoForm />
          ) : swap === "forgotpassword" ? (
            <ForgotPasswordForm />
          ) : (
            ""
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AuthModal;
